import _ from "lodash";

export class ProductDataService {

    constructor($log, $http, AppConfig) {
        'ngInject';

        this.$log = $log;
        this.$http = $http;
        this.appConfig = AppConfig;

        this._products = [];

    }

    load() {
        this.$log.debug('DataService::loadProductData');

        return this.$http.get(this.appConfig.api_endpoint + '/api/product-data', {
            ignoreLoadingBar: true
        }).then((response) => {
            this._products = response.data; //this._parseData(response.data);
            return true;
        });
    }

    getProducts() {
        return this._products;
    }

    getProfiles() {
        return _.flatMap(this.getProducts(), 'profiles');
    }

    getColourRanges() {
        return _.flatMap(this.getProfiles(), 'colour_ranges');
    }

    getColours() {
        return _.flatMap(this.getColourRanges(), 'colours');
    }

    getOptions() {
        return _.flatMap(this.getProfiles(), 'options');
    }

    getValues() {
        return _.flatMap(this.getOptions(), 'values');
    }

    getSubOptions() {
        return _.flatMap(this.getValues(), 'sub_options');
    }

    getSubOptionValues() {
        return _.flatMap(this.getSubOptions(), 'values');
    }

    getSubOptionColours() {
        return _.flatMap(this.getSubOptions(), 'colours');
    }

    getProductById(id) {
        return _.find(this.getProducts(), {id: id});
    }

    getProductProfiles(productId, doorType) {

        const typeKey = (doorType === 'double') ? 'double_asset' : 'single_asset';

        return _.filter(this.getProfiles(), (profile) => {
            return (profile.product_id === productId) && profile[typeKey] !== null;
        });
    }

    getProfileById(id) {
        return _.find(this.getProfiles, {id: id});
    }

    getProfileColourRanges(profileId) {
        return _.filter(this.getColourRanges(), {profile_id: profileId});
    }

    getColourRangeById(id) {
        return _.find(this.getColourRanges(), {id: id});
    }

    getProfileOptions(profileId) {
        return _.filter(this.getOptions(), {optionable_id: profileId});
    }

    getOptionById(id) {
        return _.find(this.getOptions(), {id: id});
    }

    getColourRangeColours(colourRangeId) {
        return _.filter(this.getColours(), function (o) {
            return o.laravel_through_key === colourRangeId;
        });
    }

    getColourById(id) {
        return _.find(this.getColours(), {id: id});
    }

    getOptionValues(optionId) {
        return _.filter(this.getValues(), {option_id: optionId});
    }

    getOptionValueById(id) {
        return _.find(this.getValues(), {id: id});
    }

    getOptionValueOptions(valueId) {
        return _.filter(this.getSubOptions(), {optionable_id: valueId});
    }

    getSubOptionById(id) {
        return _.find(this.getSubOptions(), {id: id});
    }

    getOptionValueOptionValues(optionId) {
        return _.filter(this.getSubOptionValues(), {option_id: optionId});
    }

    getSubOptionValueById() {
        return _.find(this.getSubOptionValues(), {id: id});
    }

    getOptionValueOptionColours(optionId) {
        return _.filter(this.getSubOptionColours(), {option_id: optionId});
    }

    getSubOptionColourById(id) {
        return _.find(this.getSubOptionColours(), {id: id});
    }

}



// WEBPACK FOOTER //
// ./src/js/product-data.service.js